import {
  SAVE_CONTACT_US_FAILURE,
  SAVE_CONTACT_US_REQUEST,
  SAVE_CONTACT_US_SUCCESS,
} from "./ActionType";

const initialState = {
  contactUs: {},
  loading: false,
  error: null,
};

export const contactUsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_CONTACT_US_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_CONTACT_US_SUCCESS:
      return {
        ...state,
        contactUs: action.payload,
        loading: false,
        error: null,
      };
    case SAVE_CONTACT_US_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
